import Spinner from "./spinner";

const ButtonSubmit = (props: any) => {

  let textButton = props.textButton ?? '';
  let spinner = props.spinner ?? false;
  let className = props.className ?? "";
  className = className + " btn Btn m - 1";
  let type = props.type ?? 'button';
  let disabled = ((props.disabled || spinner) ? true : false);
  return (
    <>
      <button disabled={disabled} type={type} onClick={props.handleChange} className={className}>
        {textButton}
        {spinner &&
          <Spinner />
        }
      </button >
    </>
  )
}

export default ButtonSubmit;
